import { Component, ContentChild, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  @ContentChild('head') head: TemplateRef<any>;
  @ContentChild('col1') col1: TemplateRef<any>;
  @ContentChild('col2') col2: TemplateRef<any>;
  @ContentChild('col3') col3: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }
}
